export default class MarketplaceResponseAPIResponse {
  public id?: string;
  public type?: string;
  public isVisible?: boolean;
}
